import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import workspaceApi from './plugins/workspaceApi';
import lodash from './plugins/lodash';
import helpersFunc from './plugins/helpersFunc';
import vClickOutside from "click-outside-vue3";
import Maska from 'maska';
import useToast from "./components/UI/AppToast/useToast";
import { createPinia } from 'pinia';

const app = createApp(App);
app.config.globalProperties.$toast = useToast().toast;
app.config.globalProperties.app_design_type = import.meta.env.VITE_APP_DESIGN_TYPE;

// class_design_type - преффикс для css чтобы автоматически менялся стиль при изменении версии
if (app.config.globalProperties.app_design_type === 'mguu') {
    app.config.globalProperties.class_design_type = '-mguu';
} else {
    app.config.globalProperties.class_design_type = '';
}

const pinia = createPinia()

app
    .use(store)
    .use(pinia)
    .use(router)
    .use(workspaceApi)
    .use(lodash)
    .use(helpersFunc)
    .use(vClickOutside)
    .use(Maska)

router.isReady()
    .then(() => {
        app.mount('#app');
    });